// Keeps a shared ?map= link applied for the rest of the browser tab, so a
// visitor who arrives on a saved map keeps seeing its filters as they click
// around the community site.
//
// Usage (community site layout):
// <body data-controller="map-memory" data-map-memory-map-value="01J...">
//
// Best effort: only Turbo requests get the stored map added. Full page loads
// (typed URLs, reloads, data-turbo="false" links) fall back to the default map.

import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "stoked.map"

export default class extends Controller {
  static values = {
    map: String // ULID from the current URL's ?map=, "" when absent
  }

  connect() {
    if (this.mapValue) this.store(this.mapValue)

    this.injectMap = this.injectMap.bind(this)
    document.addEventListener("turbo:before-fetch-request", this.injectMap)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.injectMap)
  }

  injectMap(event) {
    const { url, fetchOptions } = event.detail
    const map = this.stored()
    if (!map || (fetchOptions.method || "GET").toUpperCase() !== "GET") return
    if (url.origin !== window.location.origin || url.searchParams.has("map")) return

    url.searchParams.set("map", map)
  }

  stored() {
    try {
      return sessionStorage.getItem(STORAGE_KEY)
    } catch {
      return null
    }
  }

  store(map) {
    try {
      sessionStorage.setItem(STORAGE_KEY, map)
    } catch {
      // Private mode / storage disabled — the map just won't stick.
    }
  }
}
